import styled, { css } from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';

const StyledInfoContainer = styled.div`
	padding: 0 16px;
	display: flex;
	justify-content: space-between;
`;

const StyledCategory = styled(Text)`
	margin-top: 14px;
	font-size: 12px;
	color: #ffffff;
	opacity: 0.25;
	transition: color 0.3s ease;
`;

const StyledTitle = styled(Text)`
	margin-top: 4px;
	font-weight: 500;
	font-size: 14px;
	color: #ffffff;
	transition: color 0.3s ease;

	span {
		font-weight: 400;
		opacity: 0.5;
	}
`;

const StyledBottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 11px;
	gap: 10px;
`;

const StyledCountContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;

		span {
			font-weight: 400;
		}
	}
`;

const StyledTimeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	.clock {
		width: 14px;
		height: 14px;
		mask-image: url(${clock});
		mask-size: 100% 100%;
		mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-image: url(${clock});
		-webkit-mask-size: 100% 100%;
		-webkit-mask-repeat: no-repeat;
		-webkit-mask-position: center;
		background-color: #fabe2c;
		transition: background-color 0.3s ease;
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}
`;

const StyledDisabledText = styled(Text)`
	font-size: 12px;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledContainer = styled.div<{
	$active: boolean;
}>`
	display: grid;
	grid-template-columns: 90px 1px 1fr;
	width: 100%;
	height: 90px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	${(props) =>
		props.$active &&
		css`
			background-color: #2d70da;
		`}

	&:hover {
		background-color: #ffffff;

		${Divider} {
			background-color: #000000;
		}

		${StyledCategory}, ${StyledTitle}, ${StyledCountContainer} ${Text}, ${StyledTimeContainer} ${Text}, ${StyledDisabledText} {
			color: #000000;
		}

		${StyledCountContainer} img {
			filter: invert(1);
		}

		${StyledTimeContainer} .clock {
			background-color: #000000;
		}
	}
`;

const StyledImageContainer = styled.div`
	position: relative;
	width: 90px;
	height: 90px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export {
	StyledBottomContainer,
	StyledCategory,
	StyledContainer,
	StyledCountContainer,
	StyledDisabledText,
	StyledImageContainer,
	StyledInfoContainer,
	StyledTimeContainer,
	StyledTitle,
};
